module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_botanical-ef675c7feffa84b77e18537dc1cd1fbd.jpg";